import { render, staticRenderFns } from "./CardStyle.vue?vue&type=template&id=8ae9a12e&scoped=true&lang=html&"
import script from "./CardStyle.vue?vue&type=script&lang=js&"
export * from "./CardStyle.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle.vue?vue&type=style&index=0&id=8ae9a12e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae9a12e",
  null
  
)

export default component.exports